module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-6.292 13.122l-9 9a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0L14 17.172l6.878-6.878a1 1 0 0 1 1.414 0l1.414 1.414a.999.999 0 0 1 .002 1.414z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/checkmark-3.js
// module id = 1061
// module chunks = 14